// O "Acionar Parceiro" da lista de Atendimentos e o filtro de parceiros (Adnéia, 28/10/2026).
// 1) Com o motivo Ag. Parceiro filtrado, a planilha leva também os cancelamentos do AES com o
//    ticket do canal aberto (GET /api/cancelamentos/ag-parceiro, a mesma régua do
//    "+ N cancel. AES" do Dashboard), com a coluna Tipo. No lugar da anotação vai um texto fixo:
//    nada da observação do cancelamento vai ao canal (escolha dela).
// 2) Com um motivo filtrado, o filtro de parceiros mostra só os parceiros que têm essa pendência.

export const MOTIVO_AG_PARCEIRO = 'Ag. Parceiro';
export const TIPO_ATENDIMENTO = 'Atendimento';
export const TIPO_CANCELAMENTO_AES = 'Cancelamento AES';
export const TEXTO_CANCELAMENTO_AES = 'Cancelamento solicitado - aguardando retorno';

// "LL" é o LL Loyalty (Adnéia, 17/10/2026), como no Dashboard e no filtro do backend.
const MESMO_CANAL = { ll: 'LL Loyalty' };

export function nomeParceiro(p) {
  const nome = String(p || '').trim();
  return MESMO_CANAL[nome.toLowerCase()] || nome;
}

const semDecimal = (n) => String(n || '').trim().split('.')[0];

// A primeira anotação de gente. A nota automática da casa ("[DD/MM/AAAA] Casa: ...") é interna:
// não vai ao canal. Pula também as linhas vazias, para não sair "-" quando a nota da casa está no topo.
export function extrairAnotacao(anotacoes) {
  const linha = (anotacoes || '').split('\n')
    .find(l => l.trim() !== '' && !/^\s*\[[^\]]*\]\s*Casa:/.test(l)) || '';
  const mC = linha.match(/^\[(\d{1,2}\/\d{1,2}(?:\/\d{2,4})?)\]\s*(.*)$/);
  const mS = linha.match(/^(\d{1,2}\/\d{1,2}(?:\/\d{2,4})?)\s*[-–]\s*(.*)$/);
  if (mC) return { data: mC[1], texto: mC[2] || '' };
  if (mS) return { data: mS[1], texto: mS[2] || '' };
  return { data: '', texto: linha };
}

// Os cancelamentos entram só na lista do Ag. Parceiro: o motivo marcado, sem busca, sem
// categoria, sem os filtros Retornar e Verificar, e fora da lista de resolvidos.
export function cancelamentosEntramNoAcionar(filters, busca) {
  const f = filters || {};
  const motivos = Array.isArray(f.motivo_pendencia) ? f.motivo_pendencia : [];
  return motivos.includes(MOTIVO_AG_PARCEIRO)
    && f.pendente !== 'false'
    && !f.categoria
    && !f.retornar_chamado
    && !f.verificar_adneia
    && !String(busca || '').trim();
}

// Opções do filtro de parceiros: os parceiros dos atendimentos (já filtrados pelos outros
// filtros, sem o de parceiro) e, no Ag. Parceiro, os que só têm cancelamento com ticket.
// Grafias diferentes (SENFF e Senff) viram uma só, com a mais comum; os parceiros já marcados
// continuam na lista, para poder desmarcar.
export function parceirosDoFiltro(atendimentos, cancelamentosAes = [], marcados = []) {
  const porChave = new Map();
  const conta = (nome, peso) => {
    const n = nomeParceiro(nome);
    if (!n) return;
    const graf = porChave.get(n.toLowerCase()) || new Map();
    graf.set(n, (graf.get(n) || 0) + peso);
    porChave.set(n.toLowerCase(), graf);
  };
  (atendimentos || []).forEach(a => conta(a.parceiro, 1));
  (cancelamentosAes || []).forEach(c => conta(c.parceiro, 1));
  (marcados || []).forEach(m => conta(m, 0));
  return [...porChave.values()]
    .map(graf => [...graf.entries()].sort((x, y) => y[1] - x[1])[0][0])
    .sort((a, b) => a.localeCompare(b, 'pt-BR'));
}

// As linhas da planilha: os atendimentos da lista e, depois, os cancelamentos dos parceiros
// marcados (sem parceiro marcado, de todos). Um cancelamento cuja entrega já está na lista com
// a mesma solicitação não se repete.
export function linhasAcionar(atendimentos, cancelamentosAes = [], parceirosMarcados = []) {
  const linhas = (atendimentos || []).map(atd => {
    const a = extrairAnotacao(atd.anotacoes);
    return {
      tipo: TIPO_ATENDIMENTO,
      parceiro: nomeParceiro(atd.parceiro || atd.canal_vendas) || '-',
      entrega: atd.numero_pedido || '-',
      pedido: atd.pedido_externo || '-',
      solicitacao: atd.solicitacao || '-',
      cpf: atd.cpf_cliente || '-',
      data_anotacao: a.data || '-',
      anotacao: a.texto || '-',
    };
  });
  const marcados = new Set((parceirosMarcados || []).map(p => nomeParceiro(p).toLowerCase()));
  const naLista = new Set((atendimentos || []).map(atd =>
    `${semDecimal(atd.numero_pedido)}|${String(atd.solicitacao || '').trim()}`));
  (cancelamentosAes || []).forEach(c => {
    const parceiro = nomeParceiro(c.parceiro);
    if (marcados.size && !marcados.has(parceiro.toLowerCase())) return;
    const entrega = semDecimal(c.entrega);
    const solicitacao = String(c.solicitacao || '').trim();
    if (naLista.has(`${entrega}|${solicitacao}`)) return;
    linhas.push({
      tipo: TIPO_CANCELAMENTO_AES,
      parceiro: parceiro || '-',
      entrega: entrega || '-',
      pedido: c.pedido || '-',
      solicitacao: solicitacao || '-',
      cpf: c.cpf || '-',
      data_anotacao: '-',
      anotacao: TEXTO_CANCELAMENTO_AES,
    });
  });
  return linhas;
}
